import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'

import FiltersForm from '../forms/filtersForm/FiltersForm'
import SortByFilterSelect from '../forms/filtersForm/elements/SortByFilterSelect'

import '../../styles/css/components/filters/bk-flow-room-filters.css'
import triggerCustomGaEvent from '../../utilities/analytics/triggerCustomGaEvent'

class BkFlowRoomFilters extends Component {

	constructor(props) {
		super(props)
		const queryString = require('query-string')
		const urlQuery = queryString.parse(window.location.search)

		let initialSortVal = urlQuery && urlQuery.sortPriceOrder ? urlQuery.sortPriceOrder : ''

		this.state = {
			sortBy: initialSortVal,
			sortByMenuVisible: false
		}
	}

	handleToggleSortByMenu = () => {
		this.setState({
			sortByMenuVisible: !this.state.sortByMenuVisible
		})
	}

	// Manually update sort by order
	handleSelectSortBy = (sortByVal) => {
		const stayParameters = new URLSearchParams(window.location.search)

		this.setState({
			sortBy: sortByVal
		})
		stayParameters.set('sortPriceOrder', sortByVal)

		triggerCustomGaEvent('analytics-updateSortBy', sortByVal)

		// Redirect with updated parameters
		window.location.href = '/book?' + stayParameters.toString()
	}

	render() {
		const {
			roomGroup,
			configData,
			availabilityData
		} = this.props

		const hotelLabels = get(configData, 'hotel.labels[0]', [])
		let groupAvailData = null

		if (
			availabilityData &&
			availabilityData[roomGroup] &&
			availabilityData[roomGroup][0]
		) {
			groupAvailData = availabilityData[roomGroup][0]
		}

		return (
			<div className="bk-flow-room__filters">
				<div className="bk-flow-room__filters-heading">
					<h4 className="sublabel u-remove-margin">{ hotelLabels.refineResults ? hotelLabels.refineResults : 'Refine Results' }</h4>
				</div>

				{ groupAvailData &&
					<FiltersForm
						form="filtersForm"
						configData={ configData }
						hotelLabels={hotelLabels}
						groupAvailData={groupAvailData}
					/>
				}

				<SortByFilterSelect
					hotelLabels={hotelLabels}
					sortByEvent={this.handleSelectSortBy}
					sortByMenuEvent={this.handleToggleSortByMenu}
					sortByMenuVisible={this.state.sortByMenuVisible}
					sortByValue={this.state.sortBy}
				/>
			</div>
		)
	}
}

//connects root reducer to props
function mapStateToProps(state) {
	return {
		urlData: state.availabilityData.urlData,
		configData: state.configData.configuration,
		availabilityData: state.availabilityData.availability,
	}
}

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowRoomFilters)


// WEBPACK FOOTER //
// ./src/components/filters/BkFlowRoomFilters.js